module.exports = __webpack_public_path__ + "static/img/jieshao.67a4dbaf.png";